import { compact, map } from 'lodash';
import { epoch, utc } from '../../util/datetime';
import { VerificationsEmploymentOption } from './VerificationsEmployment.enum';
import type { IVerificationsEmployment } from './VerificationsEmployment.interface';

export default class VerificationsEmployment implements IVerificationsEmployment {
  method: VerificationsEmploymentOption;
  date: number;

  static build = (data: IVerificationsEmployment) => new VerificationsEmployment(data);
  static blank = () => new VerificationsEmployment();

  /**
   * Constructor
   * @param {IVerificationsEmployment} data
   */
  constructor(data?: IVerificationsEmployment) {
    this.method = map(compact(data?.method), (obj) =>
      VerificationsEmploymentOption.of(obj?.name)
    );
    this.date = data?.date ? epoch(utc(data?.date)) : 0;
  }
}
